import React from 'react';
import ObservationHoursFacility from './ObservationHoursFacility.js';
import ObservationHoursTable from './ObservationHoursTable.js';
import PatientDiagnoses from './PatientDiagnoses.js';
import PhysicalTherapistInfo from './PhysicalTherapistInfo.js';
import CheckboxField from '../../../components/controls/Form/components/CheckboxField';
import FormGroup from '../../../components/controls/Form/components/FormGroup';
import { TextParagraph } from '../../../components/controls/Typography/TextBody';
import Heading from '../../../components/controls/Typography/Heading';
import useRecommendation from '../../../utils/useRecommendation';

import './ObservationHours.less';

const ObservationHours = () => {
  const recommendation = useRecommendation();
  const recommendationRequest = recommendation.item?.recommendationRequest;
  const observationHoursDataEval = recommendation.item?.observationHoursDataEval;

  /**
   *
   * @param {string} name
   * @param {boolean} checkApprove
   */
  const saveChecklistDataObs = (name, checkApprove) => {
    // updating the store for observation hours with checkbox state
    recommendation.actions.observationHours.approveState(checkApprove);
  }

  /**
   * @param {import('../../../store/reducers/dashboardReducer').TEvaluationRequest} recommendationRequest
   * @param {import('../../../store/reducers/dashboardReducer').TObservationHoursDataEval} observationHoursDataEval
   * @returns
   */
  const renderComponent = (recommendationRequest, observationHoursDataEval) => {
    // Loop for the selected Recognization type
    const selectedRecognitionType = (observationHoursDataEval.recognitionTypes ?? []).filter(
      recognitionType => recognitionType.selected
    )?.[0]?.text;

    // Loop for the selected Experience type
    const selectedExperienceType = (observationHoursDataEval.experienceTypes ?? []).filter(
      experienceType => experienceType.selected
    )?.[0]?.text;

    // Loop for the selected RoleOfPersonShadowed type
    const selectedRoleOfPersonShadowed = (observationHoursDataEval.roleOfPersonShadows ?? []).filter(
      roleOfPersonShadowed => roleOfPersonShadowed.selected
    )?.[0]?.text;

    return <div className="lsn-observation-component">
      <div className="lsn-observation-group">
        <Heading bold level={3} tabIndex={0} asSpan aria-describedby={`obs-instructions`}>Instructions</Heading>
        <TextParagraph className="lsn-observation-text mb-2" id={`obs-instructions`}>
          {recommendationRequest.applicantFirstName} {recommendationRequest.applicantLastName} submitted the below PT
          Observation Hours as part of their PTCAS application and named you as their primary supervisor for these
          activities.
          <strong>Please review the PT Observation Hours provided by the applicant,and then indicate whether you approve of the entered information.</strong>
        </TextParagraph>
      </div>

      <ObservationHoursFacility />

      <div className='lsn-observation-group lsn-obs-summary'>
        <Heading bold level={3} tabIndex={0} asSpan className="lsn-obs-recommendation-form-header">Experience Details</Heading>
        <div className="columns">
          <div className="column col-4 col-md-12">
            <div className="columns">
              <div className="column col-12 lsn-observationHours-name"><b>Recognition Type:</b> {selectedRecognitionType}</div>
            </div>
          </div>
          <div className="column col-4 col-md-12">
            <div className="columns">
              <div className="column col-12 lsn-observationHours-name"><b>Start Date:</b> {observationHoursDataEval.startDate}</div>
            </div>
          </div>
          <div className="column col-4 col-md-12">
            <div className="columns">
              <div className="column col-12 lsn-observationHours-name"><b>End Date:</b> {observationHoursDataEval.endDate}</div>
            </div>
          </div>
        </div>
        {selectedExperienceType && (
          <div className="columns col-oneline">
            <div className="column col-12">
              <div className="columns">
                <div className="column col-3 lsn-observationHours-name">
                  <b>Experience Type:</b>
                </div>
                <div className="column col-9 lsn-observationHours-name">{selectedExperienceType}</div>
              </div>
            </div>
          </div>
        )}
        {selectedRoleOfPersonShadowed && (
          <div className="columns col-oneline">
            <div className="column col-12">
              <div className="columns">
                <div className="column col-3 lsn-observationHours-name">
                  <b>Role Of Person Shadowed:</b>
                </div>
                <div className="column col-9 lsn-observationHours-name">{selectedRoleOfPersonShadowed}</div>
              </div>
            </div>
          </div>
        )}
      </div>

      <ObservationHoursTable />
      <PatientDiagnoses />

      <div className="lsn-observation-group lsn-observation-physical-radio">
        <Heading bold level={3} tabIndex={0} asSpan className="lsn-obs-recommendation-form-header lsn-observation-font-header">Physical Therapist Response</Heading>
        <FormGroup
          label='Please select an option'
          required
          controlRender={(params) => <CheckboxField
            checked={observationHoursDataEval.checkApprove}
            onChange={saveChecklistDataObs}
            value='obsApproved'
            customValidator={(params) => {
              return params.isChecked['obsApproved'] ? params.errorMessage : 'Please Approve the PT Observation Hours Before Submission.';
            }}
            label={'I approve the PT Observation Hours entered by this applicant.'}
            {...params}
          />}
        />
        <p className="lsn-obs-check-not-approve">
          <i className="far fa-exclamation-triangle mr-2 color-orange" />
          If you cannot or do not approve of the PT Observation hours entered by this applicant, return to the Home page and decline this request.
        </p>
      </div>

      <PhysicalTherapistInfo />
    </div>
  }

  return recommendationRequest && observationHoursDataEval ? (
    renderComponent(recommendationRequest, observationHoursDataEval)
  ) : null;
}

export default ObservationHours;
